// Dutch

const lang = {
  gateMediaPreviewHeader: 'Misschien vindt u dit ook leuk',
  loadmore: 'Toon meer',
  nextMedia: 'Volgende media',
  previousMedia: 'Vorige media',
  closePost: 'Sluit post',
  nextPost: 'Volgende post',
  previousPost: 'Vorige post',
  outOfStock: 'Niet beschikbaar',
  numberOfReviews(n) {
    return n === 1 ? 'beoordeling' : 'beoordelingen'
  },
  reportFormField: 'Voer een bericht in',
  reportPost: 'Maak melding van een post',
  reportFormTitle: 'Wilt u melding maken van deze afbeelding?',
  reportFormDetails:
    'Als u van mening bent dat de afbeelding ongepast of illegaal is, of inbreuk maakt op iemands rechten, dan kunt u melding maken van de inhoud. Als u de afbeelding/tekst meldt, worden de content moderatoren van de inhoud op de hoogte gebracht en zullen passende maatregelen worden genomen.',
  reportFormMessagePlaceholder: 'Geef de reden van uw melding',
  reportFormMessageLabel: 'Bericht',
  reportFormEmailLabel: 'Uw e-mail',
  reportFormSubmitButtonText: 'Melding versturen',
  reportFormCancelButtonText: 'Annuleren',
  reportFormSentTitle: 'Bedankt voor uw verzoek!',
  reportFormSentCloseButtonText: 'Sluiten',
  cardAndTileAriaLabel:
    'Hieronder staat een lijst met posts van accounts op verschillende sociale media',
  carouselAriaLabel:
    'Hieronder staat een carrousel met posts van accounts op verschillende sociale media',
  singleAriaLabel: 'Onderstaand zie je een bericht van een social media account',
  poweredBy: 'Mogelijk gemaakt door Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` gepubliceerd op ${date}` : ''
    const createdByString = userName ? ` door ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Upload uw media',
  openTheGate: 'Open het dialoogvenster',
}

export default lang
